import {Tabs as MuiTabs, type TabsProps as MuiTabsProps} from '@mui/material';
import {getTabsSx, type TabsColor} from './tabs.styles';

const TABS_CLASS_NAME = 'MithraTabs-root';

export type CustomTabsProps = Omit<MuiTabsProps, 'textColor' | 'indicatorColor'> & {
    color?: TabsColor;
};

/** CustomTabs wraps MUI Tabs with a simplified color API. Default is gray. */
export const CustomTabs = ({
                               color = 'default',
                               className,
                               sx,
                               ...props
                           }: CustomTabsProps) => (
    <MuiTabs
        className={className ? `${TABS_CLASS_NAME} ${className}` : TABS_CLASS_NAME}
        textColor="inherit"
        indicatorColor="primary"
        sx={[getTabsSx(color), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
        {...props}
    />
);

export type {TabsColor};
export {tabsColors} from './tabs.styles';
